import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { BudgetComponent } from '../budget/budget.component';

@Component({
  selector: 'app-breakup-budget',
  templateUrl: './breakup-budget.component.html',
  styleUrls: ['./breakup-budget.component.css'],
})
export class BreakupBudgetComponent implements OnInit {
  // Define the maximum file size for uploads
  @ViewChild('budgetComponent') budgetComponent!: BudgetComponent;
  budget: FormGroup;
  // Define the maximum file size for uploads
  private saveApi = environment.url + 'coe/budgetbreakup/save';
  private getApi = environment.url + 'coe/budgetbreakup/get?id=';
  // Define the API endpoint for file uploads
  constructor(
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    this.budget = this.fb.group({
      id: [0],
      applicationId: [sessionStorage.getItem('applicationId')],
      budgetBreakdownEstablishmentEquipmentYear1: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownEstablishmentEquipmentYear2: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownEstablishmentEquipmentTotalYear: [''],

      budgetBreakdownOfficeEquipmentYear1: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownOfficeEquipmentYear2: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownOfficeEquipmentTotalYear: [''],

      budgetBreakdownNonRecurryingYear1Total: [''],
      budgetBreakdownNonRecurryingYear2Total: [''],
      budgetBreakdownNonRecurryingTotal: [''],

      budgetBreakdownRecurryingIncubationplYear1: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingIncubationplYear2: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingIncubationplTotalYear: [''],
      budgetBreakdownRecurryingMarketingplYear1: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingMarketingplYear2: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingMarketingplTotalYear: [''],

      budgetBreakdownRecurryingvpYear1: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingvpYear2: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingvpTotalYear: [''],
      budgetBreakdownRecurryingProjectAssociateYear1: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingProjectAssociateYear2: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingProjectAssociateTotalYear: [''],
      budgetBreakdownRecurryingUtilityYear1: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingUtilityYear2: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingUtilityTotalYear: [''],
      budgetBreakdownRecurryingMarketingYear1: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingMarketingYear2: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingMarketingTotalYear: [''],
      budgetBreakdownRecurryingNetworkingYear1: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingNetworkingYear2: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingNetworkingTotalYear: [''],
      budgetBreakdownRecurryingAdministrativeOverheadYear1: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingAdministrativeOverheadYear2: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingAdministrativeOverheadTotalYear: [''],
      budgetBreakdownRecurryingConsumablesYear1: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingConsumablesYear2: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingConsumablesTotalYear: [''],
      budgetBreakdownRecurryingMiscellaneousYear1: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingMiscellaneousYear2: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownRecurryingMiscellaneousTotalYear: [''],
      budgetBreakdownRecurryingYear1Total: [''],
      budgetBreakdownRecurryingYear2Total: [''],
      budgetBreakdownRecurryingTotal: [''],
      budgetBreakdownStartuptnContributionYear1: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownStartuptnContributionYear2: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownStartuptnContributionTotalYear: [''],
      budgetBreakdownHostIncContributionYear1: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownHostIncContributionYear2: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownHostIncContributionTotalYear: [''],
      budgetBreakdownIndustryContributionYear1: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownIndustryContributionYear2: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      budgetBreakdownIndustryContributionTotalYear: [''],
      budgetBreakdownTotala: [''],
      budgetBreakdownTotalb: [''],
      budgetBreakdownTotalc: [''],

      budgetBreakdownEstablishmentEquipmentDoc: [''],
      budgetBreakdownEstablishmentEquipmentDocName: [''],
      budgetBreakdownOfficeEquipmentDoc: [''],
      budgetBreakdownOfficeEquipmentDocName: [''],
      budgetBreakdownRecurryingvpDoc: [''],
      budgetBreakdownRecurryingvpDocName: [''],
      budgetBreakdownRecurryingIncubationplDoc: [''],
      budgetBreakdownRecurryingIncubationplDocName: [''],
      budgetBreakdownRecurryingUtilityDoc: [''],
      budgetBreakdownRecurryingUtilityDocName: [''],
      budgetBreakdownRecurryingMarketingplDoc: [''],
      budgetBreakdownRecurryingMarketingplDocName: [''],
      budgetBreakdownRecurryingMarketingDoc: [''],
      budgetBreakdownRecurryingMarketingDocName: [''],
      budgetBreakdownRecurryingNetworkingDoc: [''],
      budgetBreakdownRecurryingNetworkingDocName: [''],
      budgetBreakdownRecurryingAdministrativeOverheadDoc: [''],
      budgetBreakdownRecurryingAdministrativeOverheadDocName: [''],
      budgetBreakdownRecurryingConsumablesDoc: [''],
      budgetBreakdownRecurryingConsumablesDocName: [''],
      budgetBreakdownRecurryingMiscellaneousDoc: [''],
      budgetBreakdownRecurryingMiscellaneousDocName: [''],
    });
  }
  // reset form
  resetForm(): void {
    if (this.getId == 0) {
      this.budget.reset();
    }
  }
  // get data
  ngOnInit(): void {
    this.getDataApi();
  }
  // Calculate the total for establishment equipment expenses
  Optionsonechecked;
  calculateTotal1(): void {
    const year1 =
      parseFloat(
        this.budget.get('budgetBreakdownEstablishmentEquipmentYear1')?.value
      ) || 0;
    const year2 =
      parseFloat(
        this.budget.get('budgetBreakdownEstablishmentEquipmentYear2')?.value
      ) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget
      .get('budgetBreakdownEstablishmentEquipmentTotalYear')
      ?.setValue(total);
    this.calculateGrandTotal();
    this.calculateGrandTotal2();
    this.calculateGrandTotal3();
  }
  // Calculate the total for establishment equipment expenses
  calculateTotal2(): void {
    const year1 =
      parseFloat(
        this.budget.get('budgetBreakdownOfficeEquipmentYear1')?.value
      ) || 0;
    const year2 =
      parseFloat(
        this.budget.get('budgetBreakdownOfficeEquipmentYear2')?.value
      ) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget.get('budgetBreakdownOfficeEquipmentTotalYear')?.setValue(total);
    this.calculateGrandTotal();
    this.calculateGrandTotal2();
    this.calculateGrandTotal3();
  }
  // Calculate the total for office equipment expenses
  calculateGrandTotal(): void {
    const total1 =
      parseFloat(
        this.budget.get('budgetBreakdownEstablishmentEquipmentYear1')?.value
      ) || 0;
    const total2 =
      parseFloat(
        this.budget.get('budgetBreakdownOfficeEquipmentYear1')?.value
      ) || 0;
    const grandTotal = parseFloat((total1 + total2).toFixed(2));
    this.budget
      .get('budgetBreakdownNonRecurryingYear1Total')
      ?.setValue(grandTotal);
  }
  // Calculate the total for non-recurring expenses
  calculateGrandTotal2(): void {
    const total1 =
      parseFloat(
        this.budget.get('budgetBreakdownEstablishmentEquipmentYear2')?.value
      ) || 0;
    const total2 =
      parseFloat(
        this.budget.get('budgetBreakdownOfficeEquipmentYear2')?.value
      ) || 0;
    const grandTotal = parseFloat((total1 + total2).toFixed(2));
    this.budget
      .get('budgetBreakdownNonRecurryingYear2Total')
      ?.setValue(grandTotal);
  }
  // Calculate the grand total for non-recurring expenses
  calculateGrandTotal3(): void {
    const total1 =
      parseFloat(
        this.budget.get('budgetBreakdownNonRecurryingYear1Total')?.value
      ) || 0;
    const total2 =
      parseFloat(
        this.budget.get('budgetBreakdownNonRecurryingYear2Total')?.value
      ) || 0;
    const grandTotal = parseFloat((total1 + total2).toFixed(2));
    this.budget.get('budgetBreakdownNonRecurryingTotal')?.setValue(grandTotal);
  }
  calculateTotal3(): void {
    const year1 =
      parseFloat(this.budget.get('budgetBreakdownRecurryingvpYear1')?.value) ||
      0;
    const year2 =
      parseFloat(this.budget.get('budgetBreakdownRecurryingvpYear2')?.value) ||
      0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget.get('budgetBreakdownRecurryingvpTotalYear')?.setValue(total);
    this.calculateGrandTotal4();
    this.calculateGrandTotal5();
    this.calculateGrandTotal6();
  }
  // Calculate the total for recurring expenses
  calculateTotal4(): void {
    const year1 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingIncubationplYear1')?.value
      ) || 0;
    const year2 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingIncubationplYear2')?.value
      ) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget
      .get('budgetBreakdownRecurryingIncubationplTotalYear')
      ?.setValue(total);
    this.calculateGrandTotal4();
    this.calculateGrandTotal5();
    this.calculateGrandTotal6();
  }
  // Calculate the total for recurring expenses
  calculateTotal5(): void {
    const year1 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingMarketingplYear1')?.value
      ) || 0;
    const year2 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingMarketingplYear2')?.value
      ) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget
      .get('budgetBreakdownRecurryingMarketingplTotalYear')
      ?.setValue(total);
    this.calculateGrandTotal4();
    this.calculateGrandTotal5();
    this.calculateGrandTotal6();
  }
  // Calculate the total for project associate expenses
  calculateTotal6(): void {
    const year1 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingProjectAssociateYear1')?.value
      ) || 0;
    const year2 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingProjectAssociateYear2')?.value
      ) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget
      .get('budgetBreakdownRecurryingProjectAssociateTotalYear')
      ?.setValue(total);
    this.calculateGrandTotal4();
    this.calculateGrandTotal5();
    this.calculateGrandTotal6();
  }
  // Calculate the total for utility expenses
  calculateTotal7(): void {
    const year1 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingUtilityYear1')?.value
      ) || 0;
    const year2 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingUtilityYear2')?.value
      ) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget
      .get('budgetBreakdownRecurryingUtilityTotalYear')
      ?.setValue(total);
    this.calculateGrandTotal4();
    this.calculateGrandTotal5();
    this.calculateGrandTotal6();
  }
  // Calculate the total for marketing expenses
  calculateTotal8(): void {
    const year1 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingMarketingYear1')?.value
      ) || 0;
    const year2 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingMarketingYear2')?.value
      ) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget
      .get('budgetBreakdownRecurryingMarketingTotalYear')
      ?.setValue(total);
    this.calculateGrandTotal4();
    this.calculateGrandTotal5();
    this.calculateGrandTotal6();
  }
  // Calculate the total for networking expenses
  calculateTotal9(): void {
    const year1 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingNetworkingYear1')?.value
      ) || 0;
    const year2 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingNetworkingYear2')?.value
      ) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget
      .get('budgetBreakdownRecurryingNetworkingTotalYear')
      ?.setValue(total);
    this.calculateGrandTotal4();
    this.calculateGrandTotal5();
    this.calculateGrandTotal6();
  }
  // Calculate the total for administrative overhead
  calculateTotal10(): void {
    const year1 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingAdministrativeOverheadYear1')
          ?.value
      ) || 0;
    const year2 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingAdministrativeOverheadYear2')
          ?.value
      ) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget
      .get('budgetBreakdownRecurryingAdministrativeOverheadTotalYear')
      ?.setValue(total);
    this.calculateGrandTotal4();
    this.calculateGrandTotal5();
    this.calculateGrandTotal6();
  }
  // Calculate the total for all recurring expenses in year 1
  calculateTotal11(): void {
    const year1 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingConsumablesYear1')?.value
      ) || 0;
    const year2 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingConsumablesYear2')?.value
      ) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget
      .get('budgetBreakdownRecurryingConsumablesTotalYear')
      ?.setValue(total);
    this.calculateGrandTotal4();
    this.calculateGrandTotal5();
    this.calculateGrandTotal6();
  }
  // Calculate the grand total for all recurring expenses in year 1
  calculateTotal12(): void {
    const year1 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingMiscellaneousYear1')?.value
      ) || 0;
    const year2 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingMiscellaneousYear2')?.value
      ) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget
      .get('budgetBreakdownRecurryingMiscellaneousTotalYear')
      ?.setValue(total);
    this.calculateGrandTotal4();
    this.calculateGrandTotal5();
    this.calculateGrandTotal6();
  }
  // Calculate the grand total for all recurring expenses in year 1
  calculateGrandTotal4(): void {
    const total1 =
      parseFloat(this.budget.get('budgetBreakdownRecurryingvpYear1')?.value) ||
      0;
    const total2 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingIncubationplYear1')?.value
      ) || 0;
    const total3 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingMarketingplYear1')?.value
      ) || 0;
    const total4 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingProjectAssociateYear1')?.value
      ) || 0;
    const total5 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingUtilityYear1')?.value
      ) || 0;
    const total6 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingMarketingYear1')?.value
      ) || 0;
    const total7 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingNetworkingYear1')?.value
      ) || 0;
    const total8 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingAdministrativeOverheadYear1')
          ?.value
      ) || 0;
    const total9 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingConsumablesYear1')?.value
      ) || 0;
    const total10 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingMiscellaneousYear1')?.value
      ) || 0;
    const grandTotal = parseFloat(
      (
        total1 +
        total2 +
        total3 +
        total4 +
        total5 +
        total6 +
        total7 +
        total8 +
        total9 +
        total10
      ).toFixed(2)
    );
    this.budget
      .get('budgetBreakdownRecurryingYear1Total')
      ?.setValue(grandTotal);
  }
  // Calculate the grand total for all recurring expenses in year 2
  calculateGrandTotal5(): void {
    const total1 =
      parseFloat(this.budget.get('budgetBreakdownRecurryingvpYear2')?.value) ||
      0;
    const total2 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingIncubationplYear2')?.value
      ) || 0;
    const total3 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingMarketingplYear2')?.value
      ) || 0;
    const total4 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingProjectAssociateYear2')?.value
      ) || 0;
    const total5 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingUtilityYear2')?.value
      ) || 0;
    const total6 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingMarketingYear2')?.value
      ) || 0;
    const total7 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingNetworkingYear2')?.value
      ) || 0;
    const total8 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingAdministrativeOverheadYear2')
          ?.value
      ) || 0;
    const total9 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingConsumablesYear2')?.value
      ) || 0;
    const total10 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingMiscellaneousYear2')?.value
      ) || 0;
    const grandTotal = parseFloat(
      (
        total1 +
        total2 +
        total3 +
        total4 +
        total5 +
        total6 +
        total7 +
        total8 +
        total9 +
        total10
      ).toFixed(2)
    );
    this.budget
      .get('budgetBreakdownRecurryingYear2Total')
      ?.setValue(grandTotal);
  }
  // Calculate the grand total for all recurring expenses
  calculateGrandTotal6(): void {
    const total1 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingvpTotalYear')?.value
      ) || 0;
    const total2 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingProjectAssociateTotalYear')
          ?.value
      ) || 0;
    const total3 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingUtilityTotalYear')?.value
      ) || 0;
    const total4 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingMarketingTotalYear')?.value
      ) || 0;
    const total5 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingNetworkingTotalYear')?.value
      ) || 0;
    const total6 =
      parseFloat(
        this.budget.get(
          'budgetBreakdownRecurryingAdministrativeOverheadTotalYear'
        )?.value
      ) || 0;
    const total7 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingConsumablesTotalYear')?.value
      ) || 0;
    const total8 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingMiscellaneousTotalYear')
          ?.value
      ) || 0;
    const total9 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingIncubationplTotalYear')?.value
      ) || 0;
    const total10 =
      parseFloat(
        this.budget.get('budgetBreakdownRecurryingMarketingplTotalYear')?.value
      ) || 0;
    const grandTotal = parseFloat(
      (
        total1 +
        total2 +
        total3 +
        total4 +
        total5 +
        total6 +
        total7 +
        total8 +
        total9 +
        total10
      ).toFixed(2)
    );
    this.budget.get('budgetBreakdownRecurryingTotal')?.setValue(grandTotal);
  }
  // Calculate the total for startup contributions
  calculateTotal13(): void {
    const year1 =
      parseFloat(
        this.budget.get('budgetBreakdownStartuptnContributionYear1')?.value
      ) || 0;
    const year2 =
      parseFloat(
        this.budget.get('budgetBreakdownStartuptnContributionYear2')?.value
      ) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget
      .get('budgetBreakdownStartuptnContributionTotalYear')
      ?.setValue(total);
    this.calculateGrandTotal7();
    this.calculateGrandTotal8();
    this.calculateGrandTotal9();
  }
  // Calculate the total for host contributions
  calculateTotal14(): void {
    const year1 =
      parseFloat(
        this.budget.get('budgetBreakdownHostIncContributionYear1')?.value
      ) || 0;
    const year2 =
      parseFloat(
        this.budget.get('budgetBreakdownHostIncContributionYear2')?.value
      ) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget
      .get('budgetBreakdownHostIncContributionTotalYear')
      ?.setValue(total);
    this.calculateGrandTotal7();
    this.calculateGrandTotal8();
    this.calculateGrandTotal9();
  }
  // Calculate the total for industry contributions
  calculateTotal15(): void {
    const year1 =
      parseFloat(
        this.budget.get('budgetBreakdownIndustryContributionYear1')?.value
      ) || 0;
    const year2 =
      parseFloat(
        this.budget.get('budgetBreakdownIndustryContributionYear2')?.value
      ) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.budget
      .get('budgetBreakdownIndustryContributionTotalYear')
      ?.setValue(total);
    this.calculateGrandTotal7();
    this.calculateGrandTotal8();
    this.calculateGrandTotal9();
  }
  // Calculate the grand total for all contributions
  calculateGrandTotal7(): void {
    const total1 =
      parseFloat(
        this.budget.get('budgetBreakdownIndustryContributionYear1')?.value
      ) || 0;
    const total2 =
      parseFloat(
        this.budget.get('budgetBreakdownStartuptnContributionYear1')?.value
      ) || 0;
    const total3 =
      parseFloat(
        this.budget.get('budgetBreakdownHostIncContributionYear1')?.value
      ) || 0;

    const grandTotal = parseFloat((total1 + total2 + total3).toFixed(2));
    this.budget.get('budgetBreakdownTotala')?.setValue(grandTotal);
  }
  // Calculate the grand total for contributions in year 2
  calculateGrandTotal8(): void {
    const total1 =
      parseFloat(
        this.budget.get('budgetBreakdownIndustryContributionYear2')?.value
      ) || 0;
    const total2 =
      parseFloat(
        this.budget.get('budgetBreakdownStartuptnContributionYear2')?.value
      ) || 0;
    const total3 =
      parseFloat(
        this.budget.get('budgetBreakdownHostIncContributionYear2')?.value
      ) || 0;

    const grandTotal = parseFloat((total1 + total2 + total3).toFixed(2));
    this.budget.get('budgetBreakdownTotalb')?.setValue(grandTotal);
  }
  // Calculate the grand total for all contributions
  calculateGrandTotal9(): void {
    const total1 =
      parseFloat(
        this.budget.get('budgetBreakdownStartuptnContributionTotalYear')?.value
      ) || 0;
    const total2 =
      parseFloat(
        this.budget.get('budgetBreakdownHostIncContributionTotalYear')?.value
      ) || 0;
    const total3 =
      parseFloat(
        this.budget.get('budgetBreakdownIndustryContributionTotalYear')?.value
      ) || 0;

    const grandTotal = parseFloat((total1 + total2 + total3).toFixed(2));
    this.budget.get('budgetBreakdownTotalc')?.setValue(grandTotal);
  }
  // file upload
  showForm: boolean = false;
  get setting() {
    return this.budget.controls;
  }

  getValue: any = {};
  disableBtn: boolean;
  show;
  getId;
  // get data from API
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('applicationId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
        this.getId = data.id;
        if (data.edit === false) {
          this.showForm = true;
        } else {
          this.showForm = false;
        }
        if (data.responseStatus != 'Failed') {
          this.budget.patchValue(data);
          if (this.getValue.budgetBreakdownEstablishmentEquipmentDoc) {
            this.FileValue =
              this.getValue.budgetBreakdownEstablishmentEquipmentDoc;
            this.FileName =
              this.getValue.budgetBreakdownEstablishmentEquipmentDocName;
            this.disNames = '✔ Uploaded';
            this.disName = '✔ Uploaded';
          }
          if (this.getValue.budgetBreakdownOfficeEquipmentDoc) {
            this.FileValue2 = this.getValue.budgetBreakdownOfficeEquipmentDoc;
            this.FileName2 =
              this.getValue.budgetBreakdownOfficeEquipmentDocName;
            this.disNames2 = '✔ Uploaded';
            this.disName2 = '✔ Uploaded';
          }
          if (this.getValue.budgetBreakdownRecurryingvpDoc) {
            this.FileValue3 = this.getValue.budgetBreakdownRecurryingvpDoc;
            this.FileName3 = this.getValue.budgetBreakdownRecurryingvpDocName;
            this.disNames3 = '✔ Uploaded';
            this.disName3 = '✔ Uploaded';
          }
          if (this.getValue.budgetBreakdownRecurryingIncubationplDoc) {
            this.FileValue4 =
              this.getValue.budgetBreakdownRecurryingIncubationplDoc;
            this.FileName4 =
              this.getValue.budgetBreakdownRecurryingIncubationplDocName;
            this.disNames4 = '✔ Uploaded';
            this.disName4 = '✔ Uploaded';
          }
          if (this.getValue.budgetBreakdownRecurryingMarketingplDoc) {
            this.FileValue5 =
              this.getValue.budgetBreakdownRecurryingMarketingplDoc;
            this.FileName5 =
              this.getValue.budgetBreakdownRecurryingMarketingplDocName;
            this.disNames5 = '✔ Uploaded';
            this.disName5 = '✔ Uploaded';
          }
          if (this.getValue.budgetBreakdownRecurryingProjectAssociateDoc) {
            this.FileValue6 =
              this.getValue.budgetBreakdownRecurryingProjectAssociateDoc;
            this.FileName6 =
              this.getValue.budgetBreakdownRecurryingProjectAssociateDocName;
            this.disNames6 = '✔ Uploaded';
            this.disName6 = '✔ Uploaded';
          }
          if (this.getValue.budgetBreakdownRecurryingUtilityDoc) {
            this.FileValue7 = this.getValue.budgetBreakdownRecurryingUtilityDoc;
            this.FileName7 =
              this.getValue.budgetBreakdownRecurryingUtilityDocName;
            this.disNames7 = '✔ Uploaded';
            this.disName7 = '✔ Uploaded';
          }
          if (this.getValue.budgetBreakdownRecurryingMarketingDoc) {
            this.FileValue8 =
              this.getValue.budgetBreakdownRecurryingMarketingDoc;
            this.FileName8 =
              this.getValue.budgetBreakdownRecurryingMarketingDocName;
            this.disNames8 = '✔ Uploaded';
            this.disName8 = '✔ Uploaded';
          }
          if (this.getValue.budgetBreakdownRecurryingNetworkingDoc) {
            this.FileValue9 =
              this.getValue.budgetBreakdownRecurryingNetworkingDoc;
            this.FileName9 =
              this.getValue.budgetBreakdownRecurryingNetworkingDocName;
            this.disNames9 = '✔ Uploaded';
            this.disName9 = '✔ Uploaded';
          }
          if (
            this.getValue.budgetBreakdownRecurryingAdministrativeOverheadDoc
          ) {
            this.FileValue10 =
              this.getValue.budgetBreakdownRecurryingAdministrativeOverheadDoc;
            this.FileName10 =
              this.getValue.budgetBreakdownRecurryingAdministrativeOverheadDocName;
            this.disNames10 = '✔ Uploaded';
            this.disName10 = '✔ Uploaded';
          }
          if (this.getValue.budgetBreakdownRecurryingConsumablesDoc) {
            this.FileValue11 =
              this.getValue.budgetBreakdownRecurryingConsumablesDoc;
            this.FileName11 =
              this.getValue.budgetBreakdownRecurryingConsumablesDocName;
            this.disNames11 = '✔ Uploaded';
            this.disName11 = '✔ Uploaded';
          }
          if (this.getValue.budgetBreakdownRecurryingMiscellaneousDoc) {
            this.FileValue12 =
              this.getValue.budgetBreakdownRecurryingMiscellaneousDoc;
            this.FileName12 =
              this.getValue.budgetBreakdownRecurryingMiscellaneousDocName;
            this.disNames12 = '✔ Uploaded';
            this.disName12 = '✔ Uploaded';
          }
        }
      });
  }
  // file Upload
  selecetdFile: any = [];
  url: any;
  FileValue: any = '';
  FileName: any;
  documentValues = [];
  disName;
  disNames;
  maxSizeMB = 5;
  logoCheck = false;
  fileErrorShow = false;
  fileError = false;

  fileUpload(event) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      const fileSizeMB = this.selecetdFile.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          this.url = reader.result;
          let spl = this.url.split(',');
          this.FileValue = spl[1];
          this.FileName = this.selecetdFile.name;
          this.disName = '✔ Uploaded';
          this.fileError = false;
          this.fileErrorShow = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf formets are allowed');
      }
    }
  }
  // fileUpload2
  selecetdFile2: any = [];
  url2: any;
  FileValue2: any = '';
  FileName2: any;
  documentValues2 = [];
  disName2;
  disNames2;
  maxSizeMB2 = 5;
  logoCheck2 = false;
  fileErrorShow2 = false;
  fileError2 = false;
  fileUpload2(event) {
    this.selecetdFile2 = event.target.files[0];
    if (event.target.files && this.selecetdFile2) {
      const fileSizeMB = this.selecetdFile2.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB2) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile2.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile2);
        reader.onload = () => {
          this.url2 = reader.result;
          let spl = this.url2.split(',');
          this.FileValue2 = spl[1];
          this.FileName2 = this.selecetdFile2.name;
          this.disName2 = '✔ Uploaded';
          this.fileError2 = false;
          this.fileErrorShow2 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // fileUpload3
  selecetdFile3: any = [];
  url3: any;
  FileValue3: any = '';
  FileName3: any;
  documentValues3 = [];
  disName3;
  disNames3;
  maxSizeMB3 = 5;
  logoCheck3 = false;
  fileErrorShow3 = false;
  fileError3 = false;
  fileUpload3(event) {
    this.selecetdFile3 = event.target.files[0];
    if (event.target.files && this.selecetdFile3) {
      const fileSizeMB = this.selecetdFile3.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB3) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile3.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile3);
        reader.onload = () => {
          this.url3 = reader.result;
          let spl = this.url3.split(',');
          this.FileValue3 = spl[1];
          this.FileName3 = this.selecetdFile3.name;
          this.disName3 = '✔ Uploaded';
          this.fileError3 = false;
          this.fileErrorShow3 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // fileUpload4
  selecetdFile4: any = [];
  url4: any;
  FileValue4: any = '';
  FileName4: any;
  documentValues4 = [];
  disName4;
  disNames4;
  maxSizeMB4 = 5;
  logoCheck4 = false;
  fileErrorShow4 = false;
  fileError4 = false;
  fileUpload4(event) {
    this.selecetdFile4 = event.target.files[0];
    if (event.target.files && this.selecetdFile4) {
      const fileSizeMB = this.selecetdFile4.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB4) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile4.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile4);
        reader.onload = () => {
          this.url4 = reader.result;
          let spl = this.url4.split(',');
          this.FileValue4 = spl[1];
          this.FileName4 = this.selecetdFile4.name;
          this.disName4 = '✔ Uploaded';
          this.fileError4 = false;
          this.fileErrorShow4 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // fileUpload5
  selecetdFile5: any = [];
  url5: any;
  FileValue5: any = '';
  FileName5: any;
  documentValues5 = [];
  disName5;
  disNames5;
  maxSizeMB5 = 5;
  logoCheck5 = false;
  fileErrorShow5 = false;
  fileError5 = false;
  fileUpload5(event) {
    this.selecetdFile5 = event.target.files[0];
    if (event.target.files && this.selecetdFile5) {
      const fileSizeMB = this.selecetdFile5.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB5) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile5.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile5);
        reader.onload = () => {
          this.url5 = reader.result;
          let spl = this.url5.split(',');
          this.FileValue5 = spl[1];
          this.FileName5 = this.selecetdFile5.name;
          this.disName5 = '✔ Uploaded';
          this.fileError5 = false;
          this.fileErrorShow5 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // fileUpload6
  selecetdFile6: any = [];
  url6: any;
  FileValue6: any = '';
  FileName6: any;
  documentValues6 = [];
  disName6;
  disNames6;
  maxSizeMB6 = 5;
  logoCheck6 = false;
  fileErrorShow6 = false;
  fileError6 = false;
  fileUpload6(event) {
    this.selecetdFile6 = event.target.files[0];
    if (event.target.files && this.selecetdFile6) {
      const fileSizeMB = this.selecetdFile6.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB6) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile6.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile6);
        reader.onload = () => {
          this.url6 = reader.result;
          let spl = this.url6.split(',');
          this.FileValue6 = spl[1];
          this.FileName6 = this.selecetdFile6.name;
          this.disName6 = '✔ Uploaded';
          this.fileError6 = false;
          this.fileErrorShow6 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // fileUpload7
  selecetdFile7: any = [];
  url7: any;
  FileValue7: any = '';
  FileName7: any;
  documentValues7 = [];
  disName7;
  disNames7;
  maxSizeMB7 = 5;
  logoCheck7 = false;
  fileErrorShow7 = false;
  fileError7 = false;
  fileUpload7(event) {
    this.selecetdFile7 = event.target.files[0];
    if (event.target.files && this.selecetdFile7) {
      const fileSizeMB = this.selecetdFile7.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB7) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile7.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile7);
        reader.onload = () => {
          this.url7 = reader.result;
          let spl = this.url7.split(',');
          this.FileValue7 = spl[1];
          this.FileName7 = this.selecetdFile7.name;
          this.disName7 = '✔ Uploaded';
          this.fileError7 = false;
          this.fileErrorShow7 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // fileUpload8
  selecetdFile8: any = [];
  url8: any;
  FileValue8: any = '';
  FileName8: any;
  documentValues8 = [];
  disName8;
  disNames8;
  maxSizeMB8 = 5;
  logoCheck8 = false;
  fileErrorShow8 = false;
  fileError8 = false;
  fileUpload8(event) {
    this.selecetdFile8 = event.target.files[0];
    if (event.target.files && this.selecetdFile8) {
      const fileSizeMB = this.selecetdFile8.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB8) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile8.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile8);
        reader.onload = () => {
          this.url8 = reader.result;
          let spl = this.url8.split(',');
          this.FileValue8 = spl[1];
          this.FileName8 = this.selecetdFile8.name;
          this.disName8 = '✔ Uploaded';
          this.fileError8 = false;
          this.fileErrorShow8 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // fileUpload9
  selecetdFile9: any = [];
  url9: any;
  FileValue9: any = '';
  FileName9: any;
  documentValues9 = [];
  disName9;
  disNames9;
  maxSizeMB9 = 5;
  logoCheck9 = false;
  fileErrorShow9 = false;
  fileError9 = false;
  fileUpload9(event) {
    this.selecetdFile9 = event.target.files[0];
    if (event.target.files && this.selecetdFile9) {
      const fileSizeMB = this.selecetdFile9.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB9) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile9.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile9);
        reader.onload = () => {
          this.url9 = reader.result;
          let spl = this.url9.split(',');
          this.FileValue9 = spl[1];
          this.FileName9 = this.selecetdFile9.name;
          this.disName9 = '✔ Uploaded';
          this.fileError9 = false;
          this.fileErrorShow9 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // fileUpload10
  selecetdFile10: any = [];
  url10: any;
  FileValue10: any = '';
  FileName10: any;
  documentValues10 = [];
  disName10;
  disNames10;
  maxSizeMB10 = 5;
  logoCheck10 = false;
  fileErrorShow10 = false;
  fileError10 = false;
  fileUpload10(event) {
    this.selecetdFile10 = event.target.files[0];
    if (event.target.files && this.selecetdFile10) {
      const fileSizeMB = this.selecetdFile10.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB10) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile10.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile10);
        reader.onload = () => {
          this.url10 = reader.result;
          let spl = this.url10.split(',');
          this.FileValue10 = spl[1];
          this.FileName10 = this.selecetdFile10.name;
          this.disName10 = '✔ Uploaded';
          this.fileError10 = false;
          this.fileErrorShow10 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // fileUpload11
  selecetdFile11: any = [];
  url11: any;
  FileValue11: any = '';
  FileName11: any;
  documentValues11 = [];
  disName11;
  disNames11;
  maxSizeMB11 = 5;
  logoCheck11 = false;
  fileErrorShow11 = false;
  fileError11 = false;
  fileUpload11(event) {
    this.selecetdFile11 = event.target.files[0];
    if (event.target.files && this.selecetdFile11) {
      const fileSizeMB = this.selecetdFile11.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB11) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile11.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile11);
        reader.onload = () => {
          this.url11 = reader.result;
          let spl = this.url11.split(',');
          this.FileValue11 = spl[1];
          this.FileName11 = this.selecetdFile11.name;
          this.disName11 = '✔ Uploaded';
          this.fileError11 = false;
          this.fileErrorShow11 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // fileUpload12
  selecetdFile12: any = [];
  url12: any;
  FileValue12: any = '';
  FileName12: any;
  documentValues12 = [];
  disName12;
  disNames12;
  maxSizeMB12 = 5;
  logoCheck12 = false;
  fileErrorShow12 = false;
  fileError12 = false;
  fileUpload12(event) {
    this.selecetdFile12 = event.target.files[0];
    if (event.target.files && this.selecetdFile12) {
      const fileSizeMB = this.selecetdFile12.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB12) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile12.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile12);
        reader.onload = () => {
          this.url12 = reader.result;
          let spl = this.url12.split(',');
          this.FileValue12 = spl[1];
          this.FileName12 = this.selecetdFile12.name;
          this.disName12 = '✔ Uploaded';
          this.fileError12 = false;
          this.fileErrorShow12 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // cancleBtn
  cancleBtn() {
    this.showForm = false;
    this.budget.reset();
  }
  // Prevent Enter key from submitting the form
  preventEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default action
    }
  }
  // API
  @Input() parent: any;
  saveBtn(val) {
    let getform = this.budget.value;
    if (this.budget.invalid) {
      this.budget.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      if (this.FileValue != '') {
        this.fileError = false;
        getform.budgetBreakdownEstablishmentEquipmentDocName = this.FileName;
        getform.budgetBreakdownEstablishmentEquipmentDoc = this.FileValue;
      }
      if (this.FileValue2 != '') {
        this.fileError2 = false;
        getform.budgetBreakdownOfficeEquipmentDoc = this.FileValue2;
        getform.budgetBreakdownOfficeEquipmentDocName = this.FileName2;
      }
      if (this.FileValue3 != '') {
        this.fileError3 = false;
        getform.budgetBreakdownRecurryingvpDoc = this.FileValue3;
        getform.budgetBreakdownRecurryingvpDocName = this.FileName3;
      }
      if (this.FileValue4 != '') {
        this.fileError4 = false;
        getform.budgetBreakdownRecurryingIncubationplDoc = this.FileValue4;
        getform.budgetBreakdownRecurryingIncubationplDocName = this.FileName4;
      }
      if (this.FileValue5 != '') {
        this.fileError5 = false;
        getform.budgetBreakdownRecurryingMarketingplDoc = this.FileValue5;
        getform.budgetBreakdownRecurryingMarketingplDocName = this.FileName5;
      }
      if (this.FileValue6 != '') {
        this.fileError6 = false;
        getform.budgetBreakdownRecurryingProjectAssociateDoc = this.FileValue6;
        getform.budgetBreakdownRecurryingProjectAssociateDocName =
          this.FileName6;
      }
      if (this.FileValue7 != '') {
        this.fileError7 = false;
        getform.budgetBreakdownRecurryingUtilityDoc = this.FileValue7;
        getform.budgetBreakdownRecurryingUtilityDocName = this.FileName7;
      }
      if (this.FileValue8 != '') {
        this.fileError8 = false;
        getform.budgetBreakdownRecurryingMarketingDoc = this.FileValue8;
        getform.budgetBreakdownRecurryingMarketingDocName = this.FileName8;
      }
      if (this.FileValue9 != '') {
        this.fileError9 = false;
        getform.budgetBreakdownRecurryingNetworkingDoc = this.FileValue9;
        getform.budgetBreakdownRecurryingNetworkingDocName = this.FileName9;
      }
      if (this.FileValue10 != '') {
        this.fileError10 = false;
        getform.budgetBreakdownRecurryingAdministrativeOverheadDoc =
          this.FileValue10;
        getform.budgetBreakdownRecurryingAdministrativeOverheadDocName =
          this.FileName10;
      }
      if (this.FileValue11 != '') {
        this.fileError11 = false;
        getform.budgetBreakdownRecurryingConsumablesDoc = this.FileValue11;
        getform.budgetBreakdownRecurryingConsumablesDocName = this.FileName11;
      }
      if (this.FileValue12 != '') {
        this.fileError12 = false;
        getform.budgetBreakdownRecurryingMiscellaneousDoc = this.FileValue12;
        getform.budgetBreakdownRecurryingMiscellaneousDocName = this.FileName12;
      }
      getform.applicationId = sessionStorage.getItem('applicationId');
      this.getdata.amizhthLoader('show');
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseStatus);
          this.getDataApi();
          if (val == 'true') {
            this.parent.navigateToTab(3);
          }
        } else {
          this.notify.notifyError(data.responseStatus);
        }
      });
    }
  }
  previous() {
    this.parent.navigateToTab(1);
  }
}
